// frontend/src/components/LandingPage/FinalCTASection.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const FinalCTASection = () => {
    return (
        <section className="relative py-20 sm:py-24 overflow-hidden">
            {/* Background com gradiente */}
            <div className="absolute inset-0 bg-gradient-to-br from-higeia-dark via-higeia-medium to-higeia-dark" />
            
            {/* Padrão decorativo sutil */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
                    backgroundSize: '40px 40px'
                }} />
            </div>

            <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center"
                >
                    {/* Badge de Segurança */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2 }}
                        className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6"
                    >
                        <Shield className="h-4 w-4 text-white" />
                        <span className="text-sm font-medium text-white">100% Seguro e Confiável</span>
                    </motion.div>

                    {/* Título Principal */}
                    <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6">
                        Pronto para transformar sua{' '}
                        <span className="bg-gradient-to-r from-white to-higeia-light bg-clip-text text-transparent">
                            gestão de saúde?
                        </span>
                    </h2>

                    {/* Subtítulo */}
                    <p className="text-xl sm:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
                        Comece hoje mesmo, sem compromisso. Experimente todas as funcionalidades por 30 dias grátis.
                    </p>

                    {/* CTAs */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <Link to="/demonstracao">
                                <button className="px-8 py-4 text-lg font-semibold text-white border-2 border-white hover:bg-white/10 rounded-full transition-all duration-300 backdrop-blur-sm bg-white/10 flex items-center justify-center gap-2">
                                    <ArrowRight className="h-5 w-5" />
                                    Solicitar Demonstração
                                </button>
                            </Link>
                        </motion.div>
                    </div>

                    {/* Garantias */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.4 }}
                        className="flex flex-wrap justify-center gap-6 text-white/80 text-sm"
                    >
                        <div className="flex items-center gap-2">
                            <CheckCircle2 className="h-5 w-5 text-higeia-light" />
                            <span>Sem cartão de crédito</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <CheckCircle2 className="h-5 w-5 text-higeia-light" />
                            <span>Cancele quando quiser</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <CheckCircle2 className="h-5 w-5 text-higeia-light" />
                            <span>Suporte 24/7 incluído</span>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default FinalCTASection;

